import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Usuario } from '../base/vo/usuario';
import { EsqueceuSenhaService } from './esqueceu-senha.service';
import { FormValidator } from '../base/util/form-validator';

@Component({
    selector: 'app-esqueceu-senha',
    templateUrl: './esqueceu-senha.component.html',
    styleUrls: ['./esqueceu-senha.component.css']
})
export class EsqueceuSenhaComponent extends FormValidator implements OnInit {

    public usuario: Usuario = new Usuario();
    public errorMsg : string;
    public success:boolean = false;
    public loading:boolean = false;

    constructor(private esqueceuSenhaService: EsqueceuSenhaService, private router: Router) {
        super();
     }

    ngOnInit() {
    }

    public onSubmit(form){
        if(form.control.invalid){
            super.setTouchedValues(form);
            return;
        }
        this.enviar();
    }

    private enviar(){
    	if(!this.loading) {
	    	this.loading = true;
	        this.esqueceuSenhaService.enviar(this.usuario)
	            .subscribe(
	                data => {
	                	this.loading = false;
	                    this.errorMsg = '';
	                    this.success = true;
	                },
	                errorResponse => {
	                	this.loading = false;
	                	this.errorMsg = errorResponse.error.errors[0].message;
	                }
	            );
        }
    }
    
    public onClickOK() {
    	this.router.navigate(["/login"]);
    }
    
    public onChangeVisible(visible) {
    	if(!visible) {
    		this.onClickOK();
    	}
    }
}



// WEBPACK FOOTER //
// ./src/app/components/esqueceu-senha/esqueceu-senha.component.ts